import React from 'react';
import { NavLink } from 'react-router-dom';
import LocationOffIcon from '@material-ui/icons/LocationOff';
import '../../scss/components/_not_found.scss';
import { Button } from '@material-ui/core';


//Start PageNotFound component Code ....
const PageNotFoundv2 = () => {

    return (
        <React.Fragment>

            <div className="page-not-found">
                <img src={require('../../assets/images/dataPointLogo.svg')} />
                <p className="page-error">404 ERROR</p>
                <p className="not-found">Page not found</p>
                <p className="simple-text">Sorry, we could not find the page you’re looking for.</p>
                <NavLink to={`/UsersDashboard`}><Button>Go home</Button></NavLink>
            </div>

        </React.Fragment>
    );
}
export default PageNotFoundv2;
//End PageNotFound component Code ....